import type { SafeAny } from '@/common/types';
import type { EventCallBackFn, Subscription, Subscribers } from './event-bus.types';

export class EventBus {
  private subscriptions: Subscribers = {};

  subscribe(eventName: string, callback: EventCallBackFn): Subscription {
    if (!this.subscriptions[eventName]?.includes(callback)) {
      this.subscriptions[eventName] = [...(this.subscriptions[eventName] ?? []), callback];
    }

    return {
      unsubscribe: () => {
        this.subscriptions[eventName] = this.subscriptions[eventName].filter(
          (subscription) => subscription !== callback
        );
      }
    };
  }

  publish(eventName: string, payload?: SafeAny): void {
    if (!this.subscriptions[eventName]?.length) {
      return;
    }

    this.subscriptions[eventName].forEach((callback) => {
      if (typeof callback === 'function') {
        callback(payload);
      }
    });
  }
}

export const GlobalEventBus = new EventBus();
